import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { auxiliarySubscriptionQueries } from "@circle-react/lib/queries/auxiliarySubscriptions";
import { useQuery } from "react-query";

const AUXILIARY_SUBSCRIPTION_CACHE_TIME = 1000 * 60 * 60;
const AUXILIARY_SUBSCRIPTION_STALE_TIME = 1000 * 60 * 10;

export const useAuxiliarySubscriptionApi = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = Boolean(currentCommunityMember?.is_admin);

  const {
    data: auxiliarySubscription,
    isInitialLoading: isAuxiliarySubscriptionLoading,
    error: errorFetchingAuxiliarySubscription,
    refetch: refetchAuxiliarySubscription,
    isRefetching: isRefetchingAuxiliarySubscription,
  } = useQuery({
    ...auxiliarySubscriptionQueries.show(),
    retry: 2,
    enabled: isAdmin,
    gcTime: AUXILIARY_SUBSCRIPTION_CACHE_TIME,
    staleTime: AUXILIARY_SUBSCRIPTION_STALE_TIME,
  });

  return {
    auxiliarySubscription,
    storageBilling: auxiliarySubscription?.storage ?? null,
    emailHubBilling: auxiliarySubscription?.email_hub ?? null,
    aiActionsBilling: auxiliarySubscription?.ai_actions ?? null,
    isAuxiliarySubscriptionLoading,
    errorFetchingAuxiliarySubscription,
    refetchAuxiliarySubscription,
    isRefetchingAuxiliarySubscription,
  };
};
